module.exports = __webpack_public_path__ + "static/mailing_list_lokal-bc78fb77b91cbbc674ce050bcacb8b2a.png";